const dataAttr = (guard, value = "") => {
  return guard ? value : void 0;
};

export { dataAttr };
